import React from "react";

const GurukulCampus = () => {
  return <div>Gurukul Campus Page</div>;
};

export default GurukulCampus;
